import React from 'react';
import Helmet from 'react-helmet';

import ExternalAlbumUploadContainer from './ExternalAlbumUploadContainer';
import Header from '../../../../components/global/Header';
import Footer from '../../../../components/global/Footer';
import Logo from '../../../../components/global/Logo';

const ExternalAlbumUploadView = ({ ...props }) => (
  <div className="wrapper-main">
    <Helmet>
      <title>External Album Upload &ndash; Waldo</title>
    </Helmet>

    <Header>
      <div className="site-brand">
        <Logo />
      </div>
    </Header>

    <div className="content-wrap content-wrap-gray justify-content-center">
      <div className="p-xl-5 p-3">
        <ExternalAlbumUploadContainer {...props} />
      </div>
    </div>

    <Footer />
  </div>
);

export default ExternalAlbumUploadView;
